import React, { useEffect, useState } from "react";
import { Box, Button, Card, IconButton } from "@material-ui/core";
import { AttachFile, Delete } from "@material-ui/icons";
import { FilePresent } from "@mui/icons-material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import MDropdown from "../../components/MDropdown";
import MTextField from "../../components/MTextField";
import MUploadAttachment from "../../components/MUploadAttachment";
import { SnackbarType } from "../../constants/appConstants";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import {
  reactQuillFormats,
  reactQuillModules,
} from "../../constants/constants.quill";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import { setSnackbar } from "../../reducers/snackbarReducer";
import "./addHelpline.scss";

const AddHelpline = (props) => {
  const { state } = useLocation();
  const [content, setContent] = useState("");
  const [to, setTo] = useState([]);
  const [headline, setHeadline] = useState("");
  const [files, setFiles] = useState([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [helplineContacts, setHelplineContacts] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getAllHelplineContacts();
    if (state?._id) {
      getNews(state?._id);
    }
  }, []);

  const getAllHelplineContacts = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(
      navigate,
      Endpoint.GET_HELPLINE_CONTACTS,
      {},
      { status: "A" }
    )
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setHelplineContacts(response.data.data);
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching helpline contacts"));
      });
  };

  const getNews = (id) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, `${Endpoint.GET_NEWS}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setHeadline(response.data.data.headline);
          setContent(response.data.data.blog);
        } else {
          dispatch(errorSnackbar("Error while fetching News."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching News."));
      });
  };

  const handleSave = () => {
    if (getValidation()) {
      if (isFileUploaded) {
        uploadFile(0);
      } else {
        if (state?._id) {
          updateHelp();
        } else {
          addHelpApi();
        }
      }
    }
  };

  const getValidation = () => {
    let isValidated = true;
    if (to.length === 0) {
      dispatch(errorSnackbar("Please add to for the help."));
      isValidated = false;
    }
    if (isFieldEmpty(headline)) {
      dispatch(errorSnackbar("Please provide subject for the help."));
      isValidated = false;
    }
    if (isFieldEmpty(stripHTMLTags(content))) {
      dispatch(errorSnackbar("Please provide some content for the help."));
      isValidated = false;
    }

    return isValidated;
  };

  const getPocUsers = () => {
    let pocUsers = [];
    to.forEach((t) => {
      const helplineContact =
        helplineContacts[helplineContacts.map((h) => h.title).indexOf(t)];
      pocUsers = [...pocUsers, ...helplineContact.users.map((u) => u._id)];
    });
    pocUsers = [...new Set(pocUsers)];
    return pocUsers;
  };

  const addHelpApi = (fileUrls) => {
    const params = {
      users: getPocUsers(),
      subject: headline,
      description: stripHTMLTags(content),
      blog: content,
      fileUrls,
    };
    AjaxHelper.postApi(navigate, Endpoint.ADD_HELPLINE, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Help added  successfully."));
          setHeadline("");
          setTo([]);
          setContent("");
          setFiles([]);
          dispatch(
            setResponsiveDialog(
              true,
              "Info",
              "Request raised successfully.",
              "Ok"
            )
          );
        } else {
          dispatch(errorSnackbar("Error while Adding Help."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while Adding Help."));
      });
  };

  const updateHelp = (fileUrls) => {
    const params = {
      _id: state?._id,
      subject: headline,
      description: stripHTMLTags(content),
      blog: content,
      fileUrls,
    };
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_NEWS, params)
      .then((response) => {
        console.log(params, "logging params");
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("News updated successfully."));
          navigate(-1);
        } else {
          dispatch(errorSnackbar("Error while updating the news."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while updating the news."));
      });
  };

  const uploadFile = (index, paramsUploadedFiles = []) => {
    console.log(paramsUploadedFiles);
    const formData = new FormData();
    formData.append("file", files[index]);
    formData.append("key", "helpline");

    console.log(formData);
    dispatch(startLoading);
    AjaxHelper.uploadFile(navigate, Endpoint.UPLOAD_FILE, formData)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          paramsUploadedFiles.push({
            name: files[index].name,
            url: response.data.data.url,
          });
          if (files.length === index + 1) {
            if (state?._id) {
              updateHelp(paramsUploadedFiles);
            } else {
              addHelpApi(paramsUploadedFiles);
            }
          } else {
            uploadFile(index + 1, paramsUploadedFiles);
          }
        } else {
          dispatch(errorSnackbar("Error while Adding Help."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while Adding Help."));
      });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log(file);
    if (file) {
      setFiles([...files, file]);
      setIsFileUploaded(true);
    }
  };

  const stripHTMLTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  // Quill.register('modules/emoji', QuillEmoji);

  const getFileName = (fileName) => {
    const maxLength = 10;
    if (fileName) {
      const names = fileName.split(".");

      if (names[0].length > maxLength) {
        return (
          names[0].slice(0, maxLength) +
          "..." +
          names[0].slice(names.length - 5) +
          "." +
          names[1]
        );
      } else {
        return fileName;
      }
    }
  };

  const handleOnFileClick = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    if (updatedFiles.length === 0) {
      setIsFileUploaded(false);
    }
    setFiles(updatedFiles);
  };

  const handleTo = (event) => {
    const {
      target: { value },
    } = event;
    console.log(value);
    setTo(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Box>
      <Card className="addHelpCard">
        <Box className="AddHelpMainContent">
          <MDropdown
            key={"to"}
            required={true}
            label={"To"}
            name={"to"}
            value={to}
            multiple
            onChange={handleTo}
            placeholder="Select option"
            options={helplineContacts.map((h) => h.title)}
          />

          <MTextField
            placeholder="Subject"
            value={headline}
            onChange={(e) => setHeadline(e.target.value)}
          />

          <Box className="addHelpAttachments">
            {files.map((file, index) => (
              <Box className="displayAddHelpAttachments">
                <FilePresent />
                {getFileName(file.name)}
                <IconButton onClick={() => handleOnFileClick(index)}>
                  <Delete color={"error"} style={{ padding: 0 }} />
                </IconButton>
              </Box>
            ))}
            <MUploadAttachment onChange={handleImageUpload} icon={AttachFile} />
          </Box>
          <ReactQuill
            className="addHelpReactQuill"
            value={content}
            onChange={setContent}
            modules={{
              toolbar: reactQuillModules,
            }}
            formats={reactQuillFormats}
            placeholder="Write something..."
          />
        </Box>

        <Box>
          <Button
            onClick={handleSave}
            className="addHelpButton"
            variant="outlined"
          >
            {state?._id ? "Update" : "Save"}
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default AddHelpline;
